<template>
  <v-dialog v-model="dialog.value" persistent max-width="460">
    <template v-slot:activator="{ on }">
      <v-btn class="action-btn" color="success" block v-on="on">Opublikuj szkolenie</v-btn>
    </template>
    <v-card>
      <v-toolbar color="warning" dark flat>
        <v-toolbar-title>Ostrzeżenie</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="mt-4"
        ><p>Czy na pewno chcesz opublikować szkolenie?</p>
        <div>Po opublikowaniu, szkolenie stanie się możliwe do przypisania.</div>
        <div>Przypisane szkolenia są tylko do odczytu.</div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="text--secondary" text :disabled="dialog.loading" @click="dialog.value = false">Nie</v-btn>
        <v-btn color="warning" text :loading="dialog.loading" @click="submit">Tak</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapActions } = createNamespacedHelpers('courses');

export default {
  props: {
    course: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      dialog: {
        value: false,
        loading: false
      }
    };
  },
  methods: {
    ...mapActions(['finishEditing']),
    async submit() {
      try {
        this.dialog.loading = true;
        await this.finishEditing({ id: this.course.id });

        this.dialog.loading = false;
        await this.$router.push('/manage/courses');
      } catch (e) {
        // TODO: handle
        console.error(e);
      } finally {
        this.dialog.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.action-btn {
  margin-top: 8px;
  margin-bottom: 8px;
}
</style>
